import { motion } from 'motion/react'
import { BookMeButton } from '../components/BookingGuide'
import { MotionMarquee } from '../components/MotionMarquee'
import { Page } from '../components/Page'
import { ProjectGraphic } from '../components/ProjectGraphic'
import type { Project } from '../types'

export function WorkPage({ projects }: { projects: Project[] }) {
  const visibleProjects = projects.filter((project) => project.slug !== 'project-two')

  return (
    <Page className="work-page">
      <section className="work-intro">
        <MotionMarquee label="Recent Projects" level={1} scrollLinked={false} />
      </section>
      <section className="project-list" aria-label="Portfolio projects">
        {visibleProjects.map((project, index) => (
          <motion.article
            className="project-row"
            key={project.id}
            initial={{ opacity: 0, y: 38 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.64, delay: index * 0.04, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="project-meta">
              <span className="project-number">0{index + 1}</span>
              <h2>{project.title}</h2>
              <dl><div><dt>Category</dt><dd>{project.category}</dd></div><div><dt>Year</dt><dd>{project.year}</dd></div></dl>
              <p>{project.summary}</p>
              {project.externalUrl && <a className="project-link" href={project.externalUrl} target="_blank" rel="noreferrer">Visit project ↗</a>}
              {index === 0 && <BookMeButton className="project-book" />}
            </div>
            <motion.div className="project-frame" initial={{ opacity: 0, x: 32 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.16 }} transition={{ duration: 0.68, ease: [0.22, 1, 0.36, 1] }}>
              <ProjectGraphic
                src={project.mediaPath}
                alt={`${project.title} platform connections for phone, chat, company workspaces, APIs, and website integrations`}
                animated={project.title.toLowerCase() === 'twilabeth'}
              />
            </motion.div>
          </motion.article>
        ))}
      </section>
    </Page>
  )
}
